/** Create username for normal user */
$(document).on('change keyup keydown paste input blur', '#rcp_registration_form input[name="rcp_user_email"]', function () {
  var value = $(this).val();
  var formatted = '';

  if (value !== '') {
    var formatted = toKebabCase(value);
  }

  $(this).parents('form').find('.field-wrap-user_login input').val(value).trigger('change');
});